import base, { type BaseStructure } from './base';

const germanWordings: BaseStructure = base;

export default germanWordings;
